import styled from 'styled-components';

export const BarGraphsContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
